import { Route } from '@angular/router';

export const PatientsRoute: Route = {
  path: 'patients',
  loadComponent() {
    return import('@daas-consulting/production/shared/frontend/pages').then(
      (c) => c.LayoutBase2PageComponent
    );
  },
  loadChildren() {
    return import(
      '@daas-consulting/production/shared/frontend/patients_shell'
    ).then((c) => c.PatientsShellRoutes);
  },
};
